<template>
  <div class="main-wrapper">
    <roe-wizard-header
      v-slot="{ changeRoute }"
      title="Current Plan Design"
      :num="1"
      :save-action="saveChanges"
    >
      <roe-navigation-header
        :change-route="changeRoute"
        :save-action="saveChanges"
        :start-step-id="1"
        :end-step-id="9"
      ></roe-navigation-header>
    </roe-wizard-header>

    <div class="content">
      <div class="scrollable-content">
        <component
          v-bind:is="currentStep.component"
          :form-data="originalPlan"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import {
  FETCH_ORIGINAL_PLAN_PROVISION,
  FETCH_AVAILABLE_SELECT_OPTIONS,
  FETCH_COMPLIANCE_LIMITS,
  UPDATE_PLAN_PROVISION
} from "@/store/actions.type";
import { mapGetters } from "vuex";

import RoeNavigationHeader from "@/components/layouts/NavigationHeader";
import RoeWizardHeader from "@/components/layouts/WizardHeader";

export default {
  components: { RoeWizardHeader, RoeNavigationHeader },
  computed: {
    ...mapGetters(["originalPlan", "currentStep"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(FETCH_ORIGINAL_PLAN_PROVISION, to.params.id);
    return next();
  },
  mounted() {
    this.$store.dispatch(FETCH_AVAILABLE_SELECT_OPTIONS);
    this.$store.dispatch(FETCH_COMPLIANCE_LIMITS);
  },
  methods: {
    saveChanges() {
      this.$store.dispatch(UPDATE_PLAN_PROVISION, {
        plan: this.originalPlan
      });
    }
  }
};
</script>
